import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import { useCart } from '../context/CartContext';
import api from '../api';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [categories, setCategories] = useState([]);
  const location = useLocation();
  const { settings } = useSettings();
  const { cartCount } = useCart();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Fetch categories for menu
  useEffect(() => {
    api.getCategories()
      .then(data => {
        const sorted = data.sort((a, b) => {
          if ((a.sortOrder || 0) !== (b.sortOrder || 0)) {
            return (a.sortOrder || 0) - (b.sortOrder || 0);
          }
          return (a.name || '').localeCompare(b.name || '', 'vi');
        });

        setCategories(sorted);
      })
      .catch(err => console.error('Failed to load categories:', err));
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  // Build category tree: only show root categories marked for menu, with children as dropdowns
  const menuCategories = categories.filter(c => c.showInMenu && !c.parentId);

  // Menu visibility from settings
  const showGallery = settings.show_menu_gallery !== 'false';
  const showBlog = settings.show_menu_blog !== 'false';

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <Link to="/">
              {settings.logo_url ? (
                <img src={api.imageUrl(settings.logo_url)} alt={settings.shop_name} style={{ height: '60px', width: 'auto', objectFit: 'contain' }} />
              ) : (
                <h1>{settings.shop_name || ''}</h1>
              )}
            </Link>
          </div>

          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <Link to="/products" className={`nav-link ${isActive('/products')}`}>
                Sản phẩm
              </Link>
            </li>

            {/* Category menu items — each root category is a top-level nav item */}
            {menuCategories.map(cat => {
              // Find children of this category that are also marked for menu
              const children = categories.filter(c => c.parentId === cat.id && c.showInMenu);

              if (children.length > 0) {
                // Has subcategories → dropdown
                return (
                  <li key={cat.id} className="nav-item nav-dropdown">
                    <Link to={`/products?category=${cat.slug}`} className="nav-link">
                      {cat.name} <i className="fas fa-chevron-down nav-dropdown-arrow"></i>
                    </Link>
                    <ul className="nav-dropdown-menu">
                      {children.map(sub => (
                        <li key={sub.id}>
                          <Link to={`/products?category=${sub.slug}`}>{sub.name}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              }

              // No children → plain link
              return (
                <li key={cat.id} className="nav-item">
                  <Link to={`/products?category=${cat.slug}`} className="nav-link">
                    {cat.name}
                  </Link>
                </li>
              );
            })}

            {showGallery && (
              <li className="nav-item">
                <Link to="/gallery" className={`nav-link ${isActive('/gallery')}`}>
                  Bộ sưu tập
                </Link>
              </li>
            )}
            {showBlog && (
              <li className="nav-item">
                <Link to="/blog" className={`nav-link ${isActive('/blog')}`}>
                  Blog
                </Link>
              </li>
            )}
          </ul>

          <div className="nav-actions">
            <button
              className={`btn-menu-toggle ${isMenuOpen ? 'active' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <Link to="/dat-hang" className="nav-cart-link" title="Giỏ hàng">
              <img src="/images/cart.png" alt="Cart" />
              {cartCount > 0 && <span className="cart-badge-count">{cartCount}</span>}
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;